module.exports = __webpack_public_path__ + "img/bildschirmfoto05.76b6409a.png";